import { ParameterType } from '@/study-search/enums';

import { DegreeTypeFilterOptionValue, FilterOptionInformation } from '@studyportals/search-filters';
import { FilterDefinition } from '../FilterDefinition';

class BachelorsDegreeTypeFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.DEGREE_TYPE,
			[
				new FilterOptionInformation(
					'B.Sc. Bachelor of Science',
					DegreeTypeFilterOptionValue.BSC,
					DegreeTypeFilterOptionValue.BSC,
					'B.Sc.',
					'B.Sc.',
					'B.Scs'
				),
				new FilterOptionInformation(
					'B.A. Bachelor of Arts',
					DegreeTypeFilterOptionValue.BA,
					DegreeTypeFilterOptionValue.BA,
					'B.A.',
					'B.A.',
					'B.As'
				),
				new FilterOptionInformation(
					'L.L.B. Bachelor of Laws',
					DegreeTypeFilterOptionValue.LLB,
					'',
					'',
					'L.L.B.',
					'L.L.Bs'
				),
				new FilterOptionInformation(
					'B.Eng. Bachelor of Engineering',
					DegreeTypeFilterOptionValue.BENG,
					'',
					'',
					'B.Eng.',
					'B.Engs'
				),
				new FilterOptionInformation(
					'B.B.A. Bachelor of Business Administration',
					DegreeTypeFilterOptionValue.BBA,
					DegreeTypeFilterOptionValue.BBA,
					'B.B.A.',
					'B.B.A.',
					'B.B.As'
				),
				new FilterOptionInformation(
					'Associate Degree',
					DegreeTypeFilterOptionValue.ASSOCIATE_DEGREE,
					'associate-degree',
					'Associate Degree',
					'Associate Degree',
					'Associate Degrees'
				),
				new FilterOptionInformation(
					'Academy Profession',
					DegreeTypeFilterOptionValue.ACADEMY_PROFESSION,
					'',
					'',
					'Academy Profession',
					'Academy Professions'
				),
				new FilterOptionInformation(
					'Advanced Diploma',
					DegreeTypeFilterOptionValue.ADVANCED_DIPLOMA,
					'',
					'',
					'Advanced Diploma',
					'Advanced Diplomas'
				),
				new FilterOptionInformation(
					'Graduate Certificate',
					DegreeTypeFilterOptionValue.GRADUATE_CERTTIFICATE,
					'graduate-certificate',
					'Graduate Certificate',
					'Graduate Certificate',
					'Graduate Certificates'
				),
				new FilterOptionInformation(
					'Graduate Diploma',
					DegreeTypeFilterOptionValue.GRADUATE_DIPLOMA,
					'graduate-diploma',
					'Graduate Diploma',
					'Graduate Diploma',
					'Graduate Diplomas'
				),
				new FilterOptionInformation(
					'Pre-Bachelor',
					DegreeTypeFilterOptionValue.PREBACHELOR,
					DegreeTypeFilterOptionValue.PREBACHELOR,
					'Pre-Bachelor',
					'Pre-Bachelor',
					"Pre-Bachelor's"
				)
			],
			[
				DegreeTypeFilterOptionValue.BSC,
				DegreeTypeFilterOptionValue.BA,
				DegreeTypeFilterOptionValue.BBA,
				DegreeTypeFilterOptionValue.ASSOCIATE_DEGREE,
				DegreeTypeFilterOptionValue.GRADUATE_CERTTIFICATE,
				DegreeTypeFilterOptionValue.GRADUATE_DIPLOMA,
				DegreeTypeFilterOptionValue.PREBACHELOR
			]
		);
	}
}

export default new BachelorsDegreeTypeFilterDefinition();
